import { render } from "./OrderManifestVgmDetail.vue?vue&type=template&id=59d76d2a&scoped=true&ts=true"
import script from "./OrderManifestVgmDetail.vue?vue&type=script&lang=ts"
export * from "./OrderManifestVgmDetail.vue?vue&type=script&lang=ts"

import "./OrderManifestVgmDetail.vue?vue&type=style&index=0&id=59d76d2a&lang=sass&scoped=true"
import "./OrderManifestVgmDetail.vue?vue&type=style&index=1&id=59d76d2a&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59d76d2a"]])

export default __exports__